import { createAction, props } from '@ngrx/store';

export const SET_MODIFIED = createAction(
  '[ Project Prop ] Set Modified',
  props<{ modified: boolean }>()
);
